import { FieldProps } from "../../../Reusables/components/InputFieldsController/InputFieldsController.utils";

export const engagementMetaData: FieldProps[] = [
    {
      id: "formName",
      type: "text",
      label: "Form Name",
      value: "",
      placeholder: "Please enter a form name",
      width: 40,
      validation: [{ type: "required", message: "Form name is required" }],
      show: true
    },
    {
      id: "engagementLetterTemplate",
      type: "select",
      label: "Engagement Letter Template",
      value: "",
      width: 15,
      options: [],
      validation: [{ type: "required", message: "Engagement Letter Template is required" }],
      show: true
    },
    {
      id: "isFinal",
      type: "checkbox",
      label: "Final",
      value: false,
      labelPosition: "right",
      show: true
    },
  ]